
import Vue from 'vue'
import { SchoolTerm } from '@/components/formGroups'
import { SchoolTermDto } from '@ViewModels/SchoolTermDto'
import * as TermUtils from '@/services/SchoolTermService'

export default Vue.extend({
   name: 'SchoolYear',
   props: {
      terms: Array as () => SchoolTermDto[],
      start: [Date, String],
   },
   computed: {
      // The end date of the current school year
      // The datepickers won't let us choose this date or anything later
      end(): Date {
         const lastDay = TermUtils.lastAvailableDayOfSchoolYear(this.start)
         return TermUtils.addDays(lastDay, 1)
      },
   },
   methods: {
      onTermRemoved(term: SchoolTermDto) {
         this.terms.splice(this.terms.indexOf(term), 1)
         this.$emit('change')
      },
   },
   components: {
      SchoolTerm,
   },
})
